import React, { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Autocomplete, Button, Card, CircularProgress, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, TextField, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../context/userContext';
import DownloadIcon from '@mui/icons-material/Download';
import { apiUrl } from '../../../config';
import { generateYearRange } from '../../../utlis/commonFunction';
// import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';

// dayjs.extend(utc);

export default function FeeReceivableReportTwo() {
    const currentDate = new Date();
    const oneMonthAgo = new Date(currentDate);
    oneMonthAgo.setMonth(currentDate.getMonth() - 1);

    const [data, setData] = useState([]);
    const [batches, setBatches] = useState([]);
    const [branches, setBranches] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSelecting, setIsSelecting] = useState(false);

    const [filterData, setFilterData] = useState({
        name: '',
        batch: '',
        branch: '',
        year: '',
        dueDateFrom: oneMonthAgo,
        dueDateTo: new Date(),
        feeProbability: '',
    });

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [loading, setLoading] = useState(false);

    const pageOption = [10, 25, 50, 100];

    const years = generateYearRange();

    const navigate = useNavigate();
    const { permissions } = useUser();

    useEffect(() => {
        getReportsData();
    },[filterData, paginationModel]);

    useEffect(() => {
        getBranchData();
    }, []);

    useEffect(() => {
        if (!isSelecting) {
            getBatchData(searchQuery);
        }
    }, [searchQuery, isSelecting]);

    const getReportsData = async() => {
        setLoading(true);
        try {
            const studentsResponse = await apiService.get('/report/fee-receivable-two', {
                params: {
                    ...filterData,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(studentsResponse?.data?.report);
            setTotalResults(studentsResponse?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const getBranchData = async () => {
        try {
            const branchResponse = await apiService.get('/branch/list');

            setBranches(branchResponse?.data?.branchs);
        } catch (error) {
            console.error(error);
        }
    };

    const getBatchData = async (query) => {
        try {
            const batcheResponse = await apiService.get('/batch/list', {
                params: {
                    searchTerm: query,
                },
            });

            setBatches(batcheResponse?.data?.batchs);
        } catch (error) {
            console.error(error);
        }
    };

    const handleBatchSearchOptionChange = (event, newQuery, reason) => {
        if (reason === 'reset') {
            return;
        }
        setSearchQuery(newQuery);
    }

    const handleChangeSubmit = (e, value, name) => {
        if(name === 'batch') {
            setIsSelecting(true);
        }
        setFilterData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        if(name === 'batch') {
            setIsSelecting(false);
        }
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };


    const CustomOutstandingAmount = (categoryProp) => {
        const categories = categoryProp.value;

        const outStandingFee = [];

        categories?.map((category) => {

            const outStandingOts = (category?.ots?.amount > 0 &&  !category?.ots?.received && new Date(category?.ots?.dueDate) < new Date()) ? category?.ots?.amount : 0;

            const outstandingFeeFilter = category.feeSplit.filter(feeSplit => !feeSplit.received && (new Date(feeSplit?.dueDate) < new Date()));
            const outStandingFeeSplit = outstandingFeeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            const outStandingAdditionalChargeFilter = category.additionalCharge.filter(feeSplit => !feeSplit.received && new Date(feeSplit?.dueDate) < new Date());
            const outStandingAdditionalCharge = outStandingAdditionalChargeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            outStandingFee.push(outStandingOts + outStandingFeeSplit + outStandingAdditionalCharge);
        });

        return (
            <List>
                <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{outStandingFee.map(amt => amt).join(', ')}</ListItem>
            </List>
        );
    }

    const CustomDiscountAmount = (categoryProp) => {
        const categories = categoryProp.value;
        const discount = [];
        categories?.map((category) => {
            const filteredDiscount = category.discount.filter(discount => discount.discountType !== 'Instant Discount');

            const totalDiscount = filteredDiscount?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            discount.push(totalDiscount);
        });
        
        return (
            <List>
                <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{discount.map(dis => dis).join(', ')}</ListItem>
            </List>
        );
    }

    const CustomAdmissionDate = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    return <>
                        <ListItem key={category._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.applicationSubmissionDate ? new Date(category?.applicationSubmissionDate).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</ListItem>
                    </>
                })}
            </List>
        );
    }

    const CustomPaidAmount = (categoryProp) => {
        const categories = categoryProp.value;
        const paidFee = [];

        categories?.map((category) => {
            const ots = category?.ots?.amount;

            const paidFeeFilter = category.feeSplit.filter(feeSplit => feeSplit.received);
            const paidFeeSplit = paidFeeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            const paidAdditionalChargeFilter = category.additionalCharge.filter(feeSplit => feeSplit.received);
            const paidAdditionalCharge = paidAdditionalChargeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            paidFee.push(ots + paidFeeSplit + paidAdditionalCharge);
        });

        return (
            <List>
                <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{paidFee.map(paid => paid).join(', ')}</ListItem>
            </List>
        );
    }

    const CustomBalanceAmount = (categoryProp) => {
        const categories = categoryProp.value;
        const balanceFee = [];

        categories?.map((category) => {

            const balanceOts = (category?.ots?.amount > 0 &&  !category?.ots?.received) ? category?.ots?.amount : 0;

            const balanceFeeFilter = category.feeSplit.filter(feeSplit => !feeSplit.received);
            const balanceFeeSplit = balanceFeeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            const balanceAdditionalChargeFilter = category.additionalCharge.filter(feeSplit => !feeSplit.received);
            const balanceAdditionalCharge = balanceAdditionalChargeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            balanceFee.push(balanceOts + balanceFeeSplit + balanceAdditionalCharge);
        });

        return (
            <List>
                <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{balanceFee.map(amt => amt).join(', ')}</ListItem>
            </List>
        );
    }

    const CustomNotYetDue = (categoryProp) => {
        const categories = categoryProp.value;
        const balanceFee = [];

        categories?.map((category) => {

            const balanceOts = (category?.ots?.amount > 0 &&  !category?.ots?.received && new Date(category?.ots?.dueDate) >= new Date()) ? category?.ots?.amount : 0;

            const balanceFeeFilter = category.feeSplit.filter(feeSplit => !feeSplit.received && (new Date(feeSplit?.dueDate) >= new Date()));
            const balanceFeeSplit = balanceFeeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            const balanceAdditionalChargeFilter = category.additionalCharge.filter(feeSplit => !feeSplit.received && new Date(feeSplit?.dueDate) >= new Date());
            const balanceAdditionalCharge = balanceAdditionalChargeFilter?.reduce((sum, dis) => sum + parseFloat((dis.value === null || dis.value === '' || isNaN(dis.value)) ? 0 : dis.value), 0);

            balanceFee.push(balanceOts + balanceFeeSplit + balanceAdditionalCharge);
        });

        return (
            <List>
                <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{balanceFee.map(amt => amt).join(', ')}</ListItem>
            </List>
        );
    }

    const CustomBatchName = (categoryProp) => {
        const categories = categoryProp.value;

        return (
            <List>
                {categories?.map((category) => {
                    const batchName = category.batch.map((batch) => {
                        return batch.name;
                    }).join(', ');

                    return <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{batchName}</ListItem>
                    
                })}
            </List>
        );
    }

    const CustomBatchStartDate = (categoryProp) => {
        const categories = categoryProp.value;

        return (
            <List>
                {categories?.map((category) => {
                    const batchDate = category.batch.map((batch) => {
                        return new Date(batch.date).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
                    }).join(', ');

                    return <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>{batchDate}</ListItem>
                    
                })}
            </List>
        );
    }

    const navigateToStudent = (params) => {
        if(permissions.includes('updateStudent')) {
            navigate(`/dashboard/students/view?id=${params?.row?.student?._id}`);
        }
    }

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/fee-receivable-two', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                FEE RECEIVABLE REPORT TWO
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={3}>
                    <TextField
                        label="Name / Phone Number"
                        margin="normal"
                        name="name"
                        value={filterData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        label="Branch"
                        select
                        value={filterData.branch}
                        onChange={(e) => handleChange('branch', e.target.value)}
                        fullWidth
                        name="branch"
                        margin="normal"
                        required
                        size='small'
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Kozhikode">Kozhikode</MenuItem>
                        <MenuItem value="Kochi">Kochi</MenuItem>
                        <MenuItem value="Online">Online</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={3}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-batch"
                        name="batch"
                        options={batches}
                        style={{ marginTop: 10 }}
                        getOptionLabel={(option) => option.name}
                        value={batches.find((option) => option._id === filterData.batch) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value?._id, 'batch')}
                        onInputChange={handleBatchSearchOptionChange}
                        renderInput={(params) => <TextField {...params} label="Batch" />}
                        size="small"
                    />
                </Grid>
                <Grid item xs={3}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="year"
                        required
                        options={years}
                        style={{ marginTop: 10 }}
                        getOptionLabel={(option) => option}  
                        value={years.find((option) => option === filterData.year) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value, 'year')} 
                        renderInput={(params) => <TextField {...params} label="Academic Year" />}
                        size="small"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 5}}>
                <Grid item xs={4} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Due Date From"
                                value={filterData.dueDateFrom ? dayjs(filterData.dueDateFrom) : null}
                                onChange={(date) => handleChange('dueDateFrom', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Due Date To"
                                value={filterData.dueDateTo ? dayjs(filterData.dueDateTo) : null}
                                onChange={(date) => handleChange('dueDateTo', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4} sx={{ marginTop: '20px' }}>
                    <FormControl fullWidth size='small'>
                        <InputLabel id="FeeProbability">Fee Probability</InputLabel>
                        <Select
                            label="Fee Probability"
                            value={filterData.feeProbability}
                            onChange={(e) => handleChange('feeProbability', e.target.value)}
                            fullWidth
                            name='feeProbability'
                            size='small'
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="High">High</MenuItem>
                            <MenuItem value="Low">Low</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                    
                </Grid>
                <Grid item xs={8}>
                    {permissions.includes('exportFeeReceivableReport') && (
                        <Button variant="outlined" sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                    )}
                </Grid>
            </Grid>
            
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>

            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    onRowClick={navigateToStudent}
                    getRowHeight={() => 'auto'}
                    disableDensitySelector
                    columns={[
                        { field: 'student_id', headerName: 'Student ID', flex: 1, valueGetter: (params) =>  params?.row?.student?.studentId },
                        { field: 'admission_date', headerName: 'Admission Date', flex: 1, renderCell: (params) => <CustomAdmissionDate value={params?.row?.category} /> },
                        { field: 'admission_officer', headerName: 'Admission Officer', flex: 1, valueGetter: (params) =>  params?.row?.category?.map(category => category?.leadOwner).join(', ') },
                        { field: 'student_name', headerName: 'Student', flex: 1, valueGetter: (params) =>  params?.row?.student?.firstName + ' ' + params?.row?.student?.lastName },
                        { field: 'student_phone', headerName: 'Contact Number', flex: 1, valueGetter: (params) =>  params?.row?.student?.phoneNumber },
                        { field: 'course', headerName: 'Course Name', flex: 1, valueGetter: (params) =>  params?.row?.course?.name },
                        { field: 'scheme', headerName: 'Course Scheme', flex: 1, valueGetter: (params) =>  params?.row?.category?.map(category => category?.category?.name + ' (' + category?.category?.statusType + ')').join(', ') },
                        { field: 'academic_year', headerName: 'Academic Year', flex: 1, valueGetter: (params) =>  params?.row?.category?.map(category => category?.category?.year).join(', ') },
                        { field: 'total_amount', headerName: 'Total Amount', flex: 1, valueGetter: (params) =>  params?.row?.category?.map(category => category?.totalFee).join(', ') },
                        { field: 'discount_amount', headerName: 'Discount Amount', flex: 1, renderCell: (params) => <CustomDiscountAmount value={params?.row?.category} /> },
                        { field: 'paid_amount', headerName: 'Paid Amount', flex: 1, renderCell: (params) => <CustomPaidAmount value={params?.row?.category} /> },
                        { field: 'outstanding', headerName: 'Outstanding', flex: 1, renderCell: (params) => <CustomOutstandingAmount value={params?.row?.category} /> },
                        { field: 'balance_amount', headerName: 'Balance Amount', flex: 1, renderCell: (params) => <CustomBalanceAmount value={params?.row?.category} /> },
                        { field: 'batch_name', headerName: 'Batch Name', flex: 1, renderCell: (params) => <CustomBatchName value={params?.row?.category} /> },
                        { field: 'batch_start_date', headerName: 'Batch Start Date', flex: 1, renderCell: (params) => <CustomBatchStartDate value={params?.row?.category} /> },
                        { field: 'not_yet_due', headerName: 'Not Yet Due', flex: 1, renderCell: (params) => <CustomNotYetDue value={params?.row?.category} /> },
                    ]}
                    pagination
                    paginationModel={paginationModel}
                    rowCount={totalResults}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={pageOption}
                />
            )}
        </div>
    );
}
